import {Pipe, PipeTransform} from '@angular/core';
import {LinesDto} from '../../../Models/Purchases/Shared/line.interface';
import {OrderStatusEnum} from '../../../Shared/Enum/order-status.enum';

@Pipe({
  name: 'orderLines',
  standalone: false,
})
export class OrderLinesPipe implements PipeTransform {

  transform(items: LinesDto[], filter: { state: number, isClosed?: boolean }): LinesDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filter.state === OrderStatusEnum.partiallyDelivered) {
      return items.filter((item) => filter.isClosed ? item.cerrada : !item.cerrada);
    }

    return items;

  }

}
